import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'next-intl';

import { useRouter } from 'next/router';
import Link from 'next/link';
import StyledCuratedExhibitionTeasers from './curatedExhibitionTeasers.style';

import LoginMask from '../login-mask/loginMask.withRedux';
import Container from '../../layout/container/container';
import Copy from '../../atoms/copy/copy';
import Headline from '../../atoms/headline/headline';
import Image from '../../atoms/image/image';
import { LongArrowRight } from '../../icons/arrow/arrow';

const CuratedTeaserCard = ({ teaser, isStacked }) => {
  const locale = useLocale();
  return (
    <Link
      href={{
        pathname:
          locale === 'de'
            ? `/${locale}/kuratierte-fuehrung/${teaser.slug}`
            : `/${locale}/curated-exhibition/${teaser.slug}`
      }}
      className={`curatedExhibitionTeasers__container ${
        isStacked
          ? 'curatedExhibitionTeasers__container-stacked'
          : 'curatedExhibitionTeasers__container-not-stacked'
      }`}
      aria-hidden="true"
      onClick={e => {
        if (isStacked) e.preventDefault();
      }}
    >
      <div className="curatedExhibitionTeasers__teaser-image">
        <Image
          {...teaser.teaserImage}
          sizes={[
            {
              condition: 'min-width: 1100px',
              width: '438px'
            },
            {
              width: '80vw'
            }
          ]}
          lazy="default"
        />
        <span
          className={`curatedExhibitionTeasers__arrow-long curatedExhibitionTeasers__arrow-long-${
            isStacked ? 'stacked' : 'not-stacked'
          }`}
        >
          <LongArrowRight />
        </span>
      </div>
      <div className="curatedExhibitionTeasers__teaser-text">
        <Headline tag="h2">{teaser.headline}</Headline>
        <Copy
          tag="span"
          dangerouslySetInnerHTML={{
            __html:
              teaser.introCopy.length > 200
                ? `${teaser.introCopy.substring(0, 200)}...`
                : teaser.introCopy
          }}
        />
      </div>
    </Link>
  );
};

const CuratedExhibitionTeasers = ({
  headline,
  subline,
  text,
  teasers,
  loginMask,
  noMargin = false
}) => {
  const [isStacked, setIsStacked] = useState(true);
  const router = useRouter();

  return (
    <StyledCuratedExhibitionTeasers
      isDarkPage={router.pathname.includes('exhibition') || router.pathname.includes('ausstellung')}
      noMargin={noMargin}
    >
      <Container className="curatedExhibitionTeasers__text-container">
        <Copy tag="span">{subline}</Copy>
        <Headline tag="h2">{headline}</Headline>

        {text && <Copy tag="p">{text}</Copy>}
      </Container>
      <Container
        className={`curatedExhibitionTeasers__stack curatedExhibitionTeasers__is-stacked-${isStacked}`}
        onClick={() => {
          if (isStacked) setIsStacked(!isStacked);
        }}
      >
        <div className="curatedExhibitionTeasers__stack-boxes">
          {teasers.map((teaser, index) => {
            return <CuratedTeaserCard key={index} teaser={teaser} isStacked={isStacked} />;
          })}
          <a
            className={`curatedExhibitionTeasers__container curatedExhibitionTeasers__login-mask ${
              isStacked
                ? 'curatedExhibitionTeasers__container-stacked'
                : 'curatedExhibitionTeasers__container-not-stacked'
            }`}
          >
            <LoginMask {...loginMask} isTeaserCard style={{ animationDelay: `0.4s` }} />
          </a>
        </div>
      </Container>
    </StyledCuratedExhibitionTeasers>
  );
};

CuratedExhibitionTeasers.propTypes = {
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string.isRequired,
  text: PropTypes.string,
  teasers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      introCopy: PropTypes.string.isRequired,
      subline: PropTypes.string.isRequired,
      teaserImage: PropTypes.shape().isRequired
    })
  ).isRequired,
  loginMask: PropTypes.shape().isRequired,
  noMargin: PropTypes.bool
};

CuratedTeaserCard.propTypes = {
  teaser: PropTypes.shape().isRequired,
  isStacked: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  loginMask: state.app.pageData.loginMask
});

export default connect(mapStateToProps)(CuratedExhibitionTeasers);
